import React, { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import CookieConsent from "@/components/CookieConsent";

// Lazy-loaded pages for better LCP & bundle sizes
const Landing = lazy(() => import("@/pages/Landing"));
const ServiceDetail = lazy(() => import("@/pages/ServiceDetail"));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const InvoicePrint = lazy(() => import("@/pages/InvoicePrint"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense
          fallback={
            <div className="min-h-screen bg-ink-800 text-white flex items-center justify-center">
              <span className="animate-spin rounded-full h-8 w-8 border-b-2 border-lime-brand"></span>
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/service/:serviceId" element={<ServiceDetail />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/invoice/print/:invoiceId" element={<InvoicePrint />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "rgba(10,10,10,0.92)",
            border: "1px solid #2C2C2E",
            color: "#F8F9FA",
            fontFamily: "Manrope, sans-serif",
            backdropFilter: "blur(12px)",
          },
        }}
      />
      <CookieConsent />
    </div>
  );
}

export default App;
